import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5135cb1c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5135cb1c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5135cb1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5135cb1c')) {
      api.createRecord('5135cb1c', component.options)
    } else {
      api.reload('5135cb1c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5135cb1c&scoped=true", function () {
      api.rerender('5135cb1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supplierManagement/operatorsManual/index.vue"
export default component.exports